// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'circle';

export const Component = () => (
  <path d='M12.818 21.636c-2.73 0-5.029-.958-6.945-2.873C3.958 16.846 3 14.547 3 11.817c0-2.73.958-5.029 2.873-6.945C7.79 2.958 10.088 2 12.818 2c2.73 0 5.029.958 6.944 2.873 1.916 1.916 2.874 4.215 2.874 6.945-.048 2.73-1.006 5.029-2.873 6.897-1.916 1.915-4.215 2.873-6.945 2.92ZM19.045 5.59c-1.725-1.676-3.784-2.538-6.226-2.538s-4.502.862-6.178 2.538c-1.725 1.725-2.586 3.784-2.586 6.226s.861 4.502 2.586 6.178c1.676 1.725 3.736 2.586 6.178 2.586 2.442 0 4.501-.861 6.226-2.586 1.676-1.676 2.538-3.736 2.538-6.178 0-2.442-.862-4.501-2.538-6.226Z' />
);

export const viewBox = '0 0 25 25';
